import '../../resources/css/management-panel.css';
import { useSelector } from 'react-redux';

export default function ManagementPanel({ handleEdit, handleSave, handleReset }) {

    const { token } = useSelector((state) => state.environment);
    if (!token) { return null; }

    return (
        <div className="management-panel">
            <span onClick={handleEdit}>
                <i className="fa fa-pencil-square" aria-hidden="true"></i>
            </span>
            <span onClick={handleSave}>
                <i className="fa fa-floppy-o" aria-hidden="true"></i>
            </span>
            <span onClick={handleReset}>
                <i className="fa fa-refresh" aria-hidden="true"></i>
            </span>
        </div>
    );
}